
export interface SkipLinkProps {
  targetId?: string;
  label?: string;
}

/**
 * Accessible skip link for keyboard navigation.
 * Hidden by default, visible on focus.
 * Place as the first focusable element in the app layout.
 */
export function SkipLink({
  targetId = "main-content",
  label = "Zum Hauptinhalt springen",
}: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-white focus:text-black focus:underline focus:top-2 focus:left-2 focus:rounded focus:shadow-lg"
    >
      {label}
    </a>
  );
}
